import React from 'react';

import { SubMenuWrapper } from './SubMenu.styles';
import SubMenuContainer from './components/SubMenuContainer';
import SubMenuContent from './components/SubMenuContent';

type SubMenuProps = {
  isOpen: boolean;
  activeSubMenu: any;
  handleOnClose: () => void;
  handleItemOnClick: (props) => void;
};
/**
 *
 * @constructor
 */
const SubMenu = ({
  isOpen,
  activeSubMenu,
  handleOnClose,
  handleItemOnClick,
}: SubMenuProps) => (
  <SubMenuContainer isOpen={isOpen}>
    {activeSubMenu ? (
      <SubMenuWrapper
        className={activeSubMenu ? 'activeSubMenu' : ''}
        key="submenu"
      >
        <SubMenuContent
          handleItemOnClick={handleItemOnClick}
          activeSubMenu={activeSubMenu}
          handleSubMenuCloseClick={handleOnClose}
        />
      </SubMenuWrapper>
    ) : null}
  </SubMenuContainer>
);

export default SubMenu;
